function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Alert, Button, Modal, Space, notification, Statistic, InputNumber, Drawer } from "antd";
import { Row, Col } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import Common from "../includes/Common";
import OrderReceipt from "../OrderReceip";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var AddSettlement = function AddSettlement(_ref) {
  var handler = _ref.handler,
    _ref$bill = _ref.bill,
    bill = _ref$bill === void 0 ? null : _ref$bill;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    contextHolder = _Modal$useModal2[1];
  var ref = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showReceipt = _useState8[0],
    setShowReceipt = _useState8[1];
  var _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    amount = _useState0[0],
    setAmount = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    itemsList = _useState10[0],
    setItemsList = _useState10[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var exec = function exec(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    setAmount(values.amount);
    var formData = new FormData();
    formData.append('amount', values.amount);
    formData.append('bill_id', bill.id);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addsettlement', formData).then(function (response) {
      if (response.data.status == 200) {
        notification.success({
          message: "Ok!",
          description: response.data.message
        });
        setShowReceipt(true);
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var onFinish = function onFinish(values) {
    setFormError("");
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ? "
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["L'encaissement de ", values.amount.toLocaleString("Fr"), " ?"]
      }),
      onOk: function onOk() {
        exec(values);
      },
      onCancel: function onCancel() {
        setIsFormLoading(false);
      }
    });
  };
  useEffect(function () {
    bill.bill_items.forEach(function (e) {
      setItemsList(function (prev) {
        return [].concat(_toConsumableArray(prev), [e.business_account_medical_item.label]);
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 6,
        md: 6,
        sm: 6,
        children: /*#__PURE__*/_jsx(Statistic, {
          value: bill.total_amount,
          title: /*#__PURE__*/_jsx("b", {
            children: "Montant Total"
          }),
          decimalSeparator: " "
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 6,
        md: 6,
        sm: 6,
        children: /*#__PURE__*/_jsx(Statistic, {
          value: bill.total_amount - bill.paid_amount,
          title: /*#__PURE__*/_jsx("b", {
            children: "Reste \xE0 payer"
          }),
          decimalSeparator: " "
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          banner: true,
          message: formError
        })
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        wrap: true,
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "amount",
          label: "Montant",
          rules: [{
            required: true,
            message: 'Ce champs est obligatoire'
          }],
          children: /*#__PURE__*/_jsx(InputNumber, {
            style: {
              width: "150px"
            }
          })
        }), contextHolder, /*#__PURE__*/_jsx(Form.Item, {
          label: " ",
          children: /*#__PURE__*/_jsx(Button, {
            htmlType: "submit",
            icon: /*#__PURE__*/_jsx(CheckCircleFill, {}),
            disabled: bill == null,
            loading: isFormLoading,
            type: "primary",
            children: /*#__PURE__*/_jsx("b", {
              children: "Valider"
            })
          })
        })]
      })]
    }), showReceipt && bill && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(CheckCircleFill, {
          size: 30
        }), " RECU"]
      }),
      width: "280px",
      open: showReceipt,
      onClose: function onClose() {
        setShowReceipt(false);
        handler();
      },
      destroyOnClose: true,
      extra: [/*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref2) {
            var handlePrint = _ref2.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsx("b", {
                children: "Imprimer"
              })
            });
          }
        })
      })],
      children: /*#__PURE__*/_jsx("div", {
        ref: ref,
        style: {
          textAlign: 'center'
        },
        children: /*#__PURE__*/_jsx(OrderReceipt, {
          createdBill: bill,
          createdValues: bill.customer,
          discount: 0,
          receipAmount: amount,
          rdata: itemsList,
          currentCompany: null
        })
      })
    })]
  });
};
export default AddSettlement;